// extracted by mini-css-extract-plugin
export default {"settingContentContainer":"settingContentContainer-oMUmoTvn","settingTabsContainer":"settingTabsContainer-LatzwTrz"};